import React, { useEffect } from 'react';
import styles from './Login.module.scss';
import GridContainer from '@navi/web-ui/lib/layouts/Grid/GridContainer/GridContainer';
import GridRow from '@navi/web-ui/lib/layouts/Grid/GridRow/GridRow';
import GridColumn from '@navi/web-ui/lib/layouts/Grid/GridColumn/GridColumn';
import store, { RootState } from '../../../store';
import { useDispatch, useSelector } from 'react-redux';
import loginMACSVG from '../../../assets/images/Login-screen-Mac.svg';
import { useLocation, useNavigate } from 'react-router-dom';
import APP_ROUTES from '../../../layout/Routes';
import MobileNumberInputScreen from './partials/MobileNumberInputScreen';
import OTPInputScreen from './partials/OTPInputScreen';
import { titleString } from '../../../constants/Global';
import { Roles } from '../constants/AuthConstants';
import { verifyUserSession } from '../AuthActions';

const Login = () => {
  const showOTPScreen = useSelector((state: RootState) => state.auth.showOTPScreen);
  const token = useSelector((state: RootState) => state?.common?.userData?.token);

  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const navigateToCases = async () => {
    await dispatch(verifyUserSession());
  };

  const getLoginContent = (): JSX.Element => {
    return showOTPScreen ? (
      <OTPInputScreen navigateToCases={navigateToCases} />
    ) : (
      <MobileNumberInputScreen />
    );
  };

  useEffect(() => {
    titleString();
    if (token) navigateToCases();
  }, []);

  return (
    <>
      <GridContainer className={styles['zero-padding']}>
        <GridRow className={styles['auth-wrapper']}>
          <GridColumn md={6} className={styles['zero-padding']}>
            <GridContainer className={styles['zero-padding']}>
              <GridRow className={styles['auth-wrapper__login-wrapper']}>
                <GridColumn md={6}>{getLoginContent()}</GridColumn>
              </GridRow>
            </GridContainer>
          </GridColumn>
          <GridColumn md={6} className={styles['zero-padding']}>
            <GridRow className={styles['auth-wrapper__image-wrapper']}>
              <img
                onLoad={(event: any) => event.target?.classList?.add(styles['animate'])}
                src={loginMACSVG}
                alt="Login"
              />
            </GridRow>
          </GridColumn>
        </GridRow>
      </GridContainer>
    </>
  );
};

export default Login;
